<div *ngIf="requestState">
    <div class="production-operator-container py-2">
        {{ "order by" | lang }}
        <ng-select
            class="selectByOperador"
            [clearable]="false"
            [searchable]="false"
            [items]="orderBy"
            bindLabel="orderProductionOperatorText"
            bindValue="orderProductionOperatorValue"
            (change)="selectOrderBy($event)"
            [(ngModel)]="orderSelect"
            [ngClass]="{ open: selectLevelOpen, closed: !selectLevelOpen }"
            (open)="selectLevelOpen = true"
            (close)="selectLevelOpen = false"
        >
        </ng-select>
    </div>

    <div #chartTarget style="width: 100%"></div>
</div>
